import Vue from 'vue'
import App from './app.vue'
import VueRouter from 'vue-router';
Vue.use(VueRouter);

//
const routes = [
  { path: '/', name: 'check-in' },
  { path: '/:directory/:action?/:token?' },
]

//
const router = new VueRouter({
  mode: 'history',
  routes 
})

Vue.config.productionTip = false;

new Vue({
  router: router,
  render: h => h(App),
}).$mount('#app')
